// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"4de1f04f","165":"a5281565","230":"f240a556","412":"f1cde56a","457":"84bf8276","495":"2fae4a6c","529":"bf1a314d","530":"e6b8c951","564":"29553938","609":"a905b794","638":"b52c64d2","677":"f63e9d19","729":"65cc8b86","998":"825b1099"}[chunkId] + ".chunk.js";
};